import { loadScript, loadStyle } from 'common/lib/loadScript';

class AcuityWidget {
  constructor({ url, payload, onEventScheduled }) {
    this.url = new URL(url);
    this.payload = payload || {};
    // Acuity doesn't allow to determine if an event was scheduled.
    // This is an unused callback
    this.onEventScheduled = onEventScheduled;
    this.element = this._createLinkElement();

    this._loadScripts();
  }

  showPopup() {
    if (!this.isLoaded) {
      return;
    }
    this.element.click();
  }

  setUrl(url) {
    this.url = new URL(url);
  }

  closePopup() {}

  connect() {}

  disconnect() {}

  get _ownerId() {
    return this.url.searchParams.get('owner');
  }

  get _enhancedUrl() {
    const { firstName = '', lastName = '', email = '' } = this.payload.client || {};
    this.url.searchParams.set('firstName', firstName);
    this.url.searchParams.set('lastName', lastName);
    this.url.searchParams.set('email', email);

    return this.url.toString();
  }

  // This creates a hidden link element with a 'acuity-embed-button' class.
  // The Acuity JS script needs it to open a modal with a calendar.
  _createLinkElement() {
    const el = document.createElement('a');
    el.classList.add('acuity-embed-button');
    el.href = this._enhancedUrl;
    el.rel = 'noopener noreferrer';
    el.target = '_blank';
    el.style = 'display: none';
    document.body.appendChild(el);

    return el;
  }

  _loadScripts() {
    if (!this._ownerId) {
      return;
    }

    loadStyle({ url: `https://embed.acuityscheduling.com/embed/button/${this._ownerId}.css` });
    loadScript({
      id: 'acuity-widget-js',
      url: `https://embed.acuityscheduling.com/embed/button/${this._ownerId}.js`,
      callback: () => {
        this.isLoaded = true;
      },
    });
  }
}
export default AcuityWidget;
